// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Friend Card Grid */
.ua-central-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
}

/* Individual Friend Card */
.uf-profile-card-updated {
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  min-height: 280px;
}

.uf-profile-card-updated:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.15);
}

/* Friend Avatar */
.uf-profile-card-updated img {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  margin: 0 auto 12px;
  border: 2px solid rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.uf-profile-card-updated:hover img {
  box-shadow: 0 0 8px rgba(102, 126, 234, 0.2);
}

/* Friend Name */
.uf-profile-card-updated .friend-name {
  color: white;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  margin: 0 0 4px 0;
  word-break: break-word;
  line-height: 1.3;
}

/* Friend Location */
.uf-profile-card-updated .friend-location {
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  text-align: center;
  margin: 0;
}

/* Friend Status */
.uf-profile-card-updated .friend-status {
  color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
  text-align: center;
  margin: 2px 0 0 0;
}

/* Action Buttons Container */
.uf-action-buttons {
  display: flex;
  gap: 6px;
  justify-content: center;
  margin-top: auto;
}

/* Action Button */
.uf-action-buttons button {
  flex: 1 1;
  padding: 6px;
  border-radius: 4px;
  background: rgba(102, 126, 234, 0.2);
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uf-action-buttons button:hover {
  background: rgba(102, 126, 234, 0.3);
  transform: translateY(-1px);
}

/* Suggested Connection Status Badge */
.connection-badge {
  margin-top: 10px;
  padding: 4px 8px;
  background: rgba(76, 175, 80, 0.2);
  border-left: 2px solid #4caf50;
  border-radius: 3px;
  text-align: center;
}

.connection-badge p {
  margin: 0;
  font-size: 10px;
  color: #4caf50;
  font-weight: 500;
}

/* Checkbox */
input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* Responsive Design - 4 columns */
@media (max-width: 1400px) {
  .ua-central-container {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* Responsive Design - 3 columns */
@media (max-width: 1024px) {
  .ua-central-container {
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
  }
  
  .uf-profile-card-updated {
    min-height: 260px;
  }
}

/* Responsive Design - 2 columns */
@media (max-width: 768px) {
  .ua-central-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding: 16px;
  }
  
  .uf-profile-card-updated {
    min-height: 240px;
    padding: 12px;
  }
  
  .uf-profile-card-updated img {
    width: 56px;
    height: 56px;
  }
}

/* Responsive Design - 1 column mobile */
@media (max-width: 480px) {
  .ua-central-container {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 12px;
  }
  
  .uf-profile-card-updated {
    min-height: 200px;
    padding: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Components/Friends/Styles/UFGridCentreLowerLayout.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF","sourcesContent":["/* Friend Card Grid */\n.ua-central-container {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 16px;\n  padding: 20px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Individual Friend Card */\n.uf-profile-card-updated {\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.05);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  position: relative;\n  min-height: 280px;\n}\n\n.uf-profile-card-updated:hover {\n  background: rgba(255, 255, 255, 0.08);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.15);\n}\n\n/* Friend Avatar */\n.uf-profile-card-updated img {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin: 0 auto 12px;\n  border: 2px solid rgba(102, 126, 234, 0.3);\n  transition: all 0.3s ease;\n}\n\n.uf-profile-card-updated:hover img {\n  box-shadow: 0 0 8px rgba(102, 126, 234, 0.2);\n}\n\n/* Friend Name */\n.uf-profile-card-updated .friend-name {\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  text-align: center;\n  margin: 0 0 4px 0;\n  word-break: break-word;\n  line-height: 1.3;\n}\n\n/* Friend Location */\n.uf-profile-card-updated .friend-location {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 11px;\n  text-align: center;\n  margin: 0;\n}\n\n/* Friend Status */\n.uf-profile-card-updated .friend-status {\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 10px;\n  text-align: center;\n  margin: 2px 0 0 0;\n}\n\n/* Action Buttons Container */\n.uf-action-buttons {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n  margin-top: auto;\n}\n\n/* Action Button */\n.uf-action-buttons button {\n  flex: 1;\n  padding: 6px;\n  border-radius: 4px;\n  background: rgba(102, 126, 234, 0.2);\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.uf-action-buttons button:hover {\n  background: rgba(102, 126, 234, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Suggested Connection Status Badge */\n.connection-badge {\n  margin-top: 10px;\n  padding: 4px 8px;\n  background: rgba(76, 175, 80, 0.2);\n  border-left: 2px solid #4caf50;\n  border-radius: 3px;\n  text-align: center;\n}\n\n.connection-badge p {\n  margin: 0;\n  font-size: 10px;\n  color: #4caf50;\n  font-weight: 500;\n}\n\n/* Checkbox */\ninput[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n/* Responsive Design - 4 columns */\n@media (max-width: 1400px) {\n  .ua-central-container {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n/* Responsive Design - 3 columns */\n@media (max-width: 1024px) {\n  .ua-central-container {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n  }\n  \n  .uf-profile-card-updated {\n    min-height: 260px;\n  }\n}\n\n/* Responsive Design - 2 columns */\n@media (max-width: 768px) {\n  .ua-central-container {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n    padding: 16px;\n  }\n  \n  .uf-profile-card-updated {\n    min-height: 240px;\n    padding: 12px;\n  }\n  \n  .uf-profile-card-updated img {\n    width: 56px;\n    height: 56px;\n  }\n}\n\n/* Responsive Design - 1 column mobile */\n@media (max-width: 480px) {\n  .ua-central-container {\n    grid-template-columns: 1fr;\n    gap: 10px;\n    padding: 12px;\n  }\n  \n  .uf-profile-card-updated {\n    min-height: 200px;\n    padding: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
